import { render, staticRenderFns } from "./PolestarDisclosure.vue?vue&type=template&id=51e3e9ba&"
import script from "./PolestarDisclosure.vue?vue&type=script&lang=js&"
export * from "./PolestarDisclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports